import { useEffect } from "react";
import { Outlet, useMatch, useNavigate, generatePath } from "react-router-dom";

import { useGlobalFiltersContext } from "contexts/filters";
import {
  RISK_ROUTE_CHARTS_MAJOR,
  RISK_ROUTE_CHARTS_MITIGATION,
  RISK_ROUTE_CHARTS_OVERALL,
} from "constants/routing";

export const RiskManagementCharts = () => {
  const navigate = useNavigate();

  const riskOverallRouteMatch = useMatch({
    path: RISK_ROUTE_CHARTS_OVERALL,
    end: false,
  });

  const riskMitigationRouteMatch = useMatch({
    path: RISK_ROUTE_CHARTS_MITIGATION,
    end: false,
  });

  const { wellIdNameParam, appliedRiskMitigationId } =
    useGlobalFiltersContext();

  useEffect(() => {
    const getRiskPath = (
      riskMitigationPathNameBase?: string,
      riskOverallPathNameBase?: string,
      appliedRiskMitigationId?: number,
    ) => {
      // if mitigation is selected, overall and /major /charts reroute to /mitigation
      if (appliedRiskMitigationId) {
        return `${RISK_ROUTE_CHARTS_MITIGATION}/${wellIdNameParam}`;
      }

      if (riskMitigationPathNameBase || riskOverallPathNameBase) {
        return `${RISK_ROUTE_CHARTS_OVERALL}/${wellIdNameParam}`;
      }

      return `${RISK_ROUTE_CHARTS_MAJOR}/${wellIdNameParam}`;
    };

    if (wellIdNameParam) {
      navigate(
        generatePath(
          getRiskPath(
            riskMitigationRouteMatch?.pathnameBase,
            riskOverallRouteMatch?.pathnameBase,
            appliedRiskMitigationId,
          ),
        ),
        {
          replace: true,
        },
      );
    }
  }, [
    navigate,
    wellIdNameParam,
    riskMitigationRouteMatch?.pathnameBase,
    riskOverallRouteMatch?.pathnameBase,
    appliedRiskMitigationId,
  ]);

  return <Outlet />;
};

export default RiskManagementCharts;
